"use client"

import * as React from "react";
import styles from "./styles/SchoolFeedPageWrapperHeader.module.scss";
import SubmitOrganizationButton from "./SubmitOrganizationButton";
import FontAwesome from "../../utilities/FontAwesome";
import classNames from "classnames";
import {navigationContent, RecursiveRcMenu} from "../navigation/MobileNav/MobileNav";
import {useComponentVisible} from "../../../hooks/useComponentVisible";
import {useIsCollectionPage} from "../../../hooks/useIsCollectionPage";
import {IView} from "../../../stores/InterfaceStore";
import ModalBackdrop from "../../modals/_ModalBackdrop";
import zIndex from "../../../styles/_zIndex.module.scss";
import {useStores} from "../../../stores/useStores";
import {observer} from "mobx-react";
import SchoolFeedSearchFilters from "../schoolfeed/SchoolFeedSearchFilter";
import {useSchoolFeedTitle} from "../../../hooks/useSchoolFeedTitle";

const SchoolFeedSubmitOrganizationHeader = () => {
    const {organizationStore} = useStores();

    const categoryTree = organizationStore.currentOrganization?.category_tree

    let organizationTitle = 'Organization'
    if (categoryTree && categoryTree.length === 1) {
        organizationTitle = categoryTree[0].category_name
    }

    const message = `${organizationTitle}s offer their own news, events, and discussion leaderboards.`

    return <div className={styles.submitButtonContainer}>
        <span>{message}</span>
        <SubmitOrganizationButton url={"/claim"} text={`List your ${organizationTitle}`}/>
    </div>
}

export const SchoolFeedPageWrapperHeader = observer((props) => {
    const {organizationStore, interfaceStore} = useStores();

    const content = navigationContent(organizationStore)

    const {ref, setIsComponentVisible, isComponentVisible} = useComponentVisible(false);
    const title = useSchoolFeedTitle();

    const menuContainerClassName = classNames({
        [styles.sidebarMenu]: true,
        [styles.sidebarMenuOpen]: isComponentVisible,
    })

    const showFilters = [
        IView.DEFAULT,
        IView.SCHOOLFEED_PAGE,
        IView.MAP,
        IView.ALPHA,
        IView.LEADERBOARD,
        IView.CLAIM,
    ].includes(interfaceStore.view as IView);

    return <div className={styles.headerContainer}>
        <div className={menuContainerClassName}>
            <button aria-label={"Close Navigation"} className={styles.closeButton}
                    onClick={() => setIsComponentVisible(false)}>
                <FontAwesome name={"fa-times"} prefix={'fas'}/>
            </button>
            <RecursiveRcMenu
                content={content}
                isSubMenu={false}
                mode={"inline"}
                className={styles.menuContainer}
                selectable={false}
                motion={{
                    motionName: "rc-menu-collapse",
                    motionEnter: true,
                    motionLeave: true,
                    onEnterStart: () => ({height: 0}),
                    onEnterActive: (el) => ({"height": `calc(${el.children.length * 2}rem + ${el.children.length * 16}px)`}),
                    onLeaveStart: (el) => ({"height": `calc(${el.children.length * 2}rem + ${el.children.length * 16}px)`}),
                    onLeaveActive: () => ({height: 0}),
                }}
            />
        </div>
        {organizationStore.navigation.length > 0 && <div ref={ref} className={styles.menuHamburgerButton}>
            <button aria-label={"Open Navigation"} onClick={() => setIsComponentVisible(true)}>
                <FontAwesome name={"fa-bars"} size={"2x"} prefix={'fas'}/>
            </button>
        </div>}
        <div style={{display: "inline-block"}}>
            <h2>{title}</h2>
        </div>
        {showFilters && <SchoolFeedSearchFilters
            className={styles.searchFilters}
        />}
        {useIsCollectionPage() && <SchoolFeedSubmitOrganizationHeader/>}
        {isComponentVisible && <ModalBackdrop
            active={true}
            onMouseDown={() => setIsComponentVisible(false)}
            zIndex={parseInt(zIndex["z-index-cleverfeed-sidebar"]) - 1}
        />}
    </div>
})
